<template>
  <div :class="{ 'has-logo': showLogo }" :style="cssVars">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger"
      @toggleClick="toggleSideBar"
    />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :popper-append-to-body="false"
        :style="cssVars"
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="backgroundColor || '#34495e'"
        :text-color="textColor || '#fff'"
        :unique-opened="false"
        :active-text-color="activeTextColor || '#fff'"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in concatRoutes()"
          :key="route.permissionKey"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Logo from "./Logo";
import SidebarItem from "./SidebarItem";
import variables from "./variables.scss";
import Hamburger from "@/CommonDP/components/Hamburger";
import { mapGetters } from "vuex";
import { getMenuListApplication } from "@/CommonDP/utils/tree";
import globalParams from "@/CommonDP/utils/globalParams";

export default {
  components: { SidebarItem, Logo, Hamburger },

  data() {
    return {
      activeBgColor: this.leftMenuStyle("activeBgColor"),
      activeTextColor: this.leftMenuStyle("activeTextColor"),
      backgroundColor: this.leftMenuStyle("backgroundColor"),
      textColor: this.leftMenuStyle("textColor"),
      iconArrowColor: this.leftMenuStyle("iconArrowColor"),
      unfoldColor: this.leftMenuStyle("unfoldColor")
    };
  },

  computed: {
    ...mapGetters(["sidebar"]),
    ...mapState({
      authRoutes: state => state.router.authRoutes,
      authProjectRoutes: state => state.router.authProjectRoutes
    }),
    activeMenu() {
      const route = this.$route;
      const { path } = route;
      return path;
    },
    showLogo() {
      return true;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    },

    cssVars() {
      return {
        "--activeBgColor": this.activeBgColor,
        "--activeTextColor": this.activeTextColor,
        "--backgroundColor": this.backgroundColor,
        "--textColor": this.textColor,
        "--iconArrowColor": this.iconArrowColor,
        "--unfoldColor": this.unfoldColor
      };
    }
  },

  methods: {
    toggleSideBar() {
      this.$store.dispatch("toggleSideBar");
    },

    leftMenuStyle(key) {
      const leftMenuStyle = globalParams.get("leftMenuStyle") || {};
      return leftMenuStyle[key];
    },

    concatRoutes() {
      const copyAuthRoutes = JSON.parse(
        JSON.stringify(getMenuListApplication(this.authRoutes))
      );
      const copyAuthProjectRoutes = JSON.parse(
        JSON.stringify(getMenuListApplication(this.authProjectRoutes))
      );
      if (globalParams.get('handleLeftFoldMenu')) {
        copyAuthRoutes = globalParams.get('handleLeftFoldMenu')(copyAuthRoutes);
      }
      try {
        const index = copyAuthRoutes.findIndex(
          item => item.permissionKey === "project"
        );
        if (!copyAuthProjectRoutes[0]) {
          return copyAuthRoutes;
        }
        copyAuthRoutes.splice(index, 1, copyAuthProjectRoutes[0]);
        return copyAuthRoutes;
      } catch (e) {
        return copyAuthRoutes;
      }
    }
  }
};
</script>

<style lang="scss">
@import "variables";
@import "sidebar";
</style>

<style lang="scss" scoped>
/deep/ .hamburger {
  i {
    color: var(--unfoldColor, #fff) !important;
  }
}
/deep/ .el-scrollbar {
  .el-scrollbar__view {
    .el-submenu__icon-arrow {
      color: var(--iconArrowColor, #fff) !important;
    }
    .submenu-title-noDropdown,
    .el-submenu__title {
      color: var(--textColor, #fff) !important;
      &:hover {
        background-color: var(
          --activeBgColor,
          rgba(255, 255, 255, 0.2)
        ) !important;
      }
    }
    .nest-menu .el-submenu > .el-submenu__title,
    .el-submenu .el-menu-item {
      &:hover {
        background-color: var(
          --activeBgColor,
          rgba(255, 255, 255, 0.2)
        ) !important;
      }
      &.is-active {
        background-color: var(
          --activeBgColor,
          rgba(255, 255, 255, 0.2)
        ) !important;
        color: var(--activeTextColor, #fff) !important;
      }
    }
  }
}
</style>
